export const DEVELOPMENT = 'development';

export const SET_OPTION = 'SET_OPTION';
export const RESET_OPTION = 'RESET_OPTION';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const GET_DEVELOP = 'GET_DEVELOP';
export const GET_SOUND = 'GET_SOUND';
export const GET_DESIGN = 'GET_DESIGN';
export const SET_MENU = 'SET_MENU';
export const GET_LOGIN = 'GET_LOGIN';
export const SET_INFO = 'SET_INFO';
export const GET_WIKI = 'GET_WIKI';
export const GET_DEVDAILYJOKE = 'GET_DEVDAILYJOKE';
export const GET_LASTS = 'GET_LASTS';
export const SET_INDEX = 'SET_INDEX';
export const RESET_INFO = 'RESET_INFO';
export const GET_EXPERIENCE = 'GET_EXPERIENCE';